module.exports = __webpack_public_path__ + "s/img/Chill_D_5.bb907238.jpg";